module.exports = __webpack_public_path__ + "img/zqy_268v_icon.7adeab51.png";